import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import About from '../components/About';
import Industries from '../components/Industries';
import Services from '../components/Services';
import CompanyShowcase from '../components/CompanyShowcase';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import Clients from '../components/Clients';
import HelpSection from '../components/HelpSection';

const HomePage = () => {
    return (
        <>
            <Hero />
            <Stats />
            <About />
            <Industries />
            <Services />
            <CompanyShowcase />
            <WhyChooseUs />
            <Testimonials />
            <Clients />
            <HelpSection />
        </>
    );
};

export default HomePage;
